import * as React from 'react'

export const ArrowRightIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.6875 10.7188L11.6875 15.7188C11.3125 16.125 10.6562 16.125 10.2812 15.7188C9.875 15.3438 9.875 14.6875 10.2812 14.3125L13.5625 11H4C3.4375 11 3 10.5625 3 10C3 9.46875 3.4375 9 4 9H13.5625L10.2812 5.71875C9.875 5.34375 9.875 4.6875 10.2812 4.3125C10.6562 3.90625 11.3125 3.90625 11.6875 4.3125L16.6875 9.3125C17.0938 9.6875 17.0938 10.3438 16.6875 10.7188Z"
        fill="currentColor"
      />
    </svg>
  )
}
